/**
 * One-shot "flash" toast that survives a hard navigation.
 *
 * sonner toasts are cleared on a full page reload (`window.location.href`), so
 * an action that reloads the page — entering / exiting impersonation — can't
 * just call `toast.success()` then navigate: the toast is wiped before it ever
 * paints. Instead it stashes the message here (sessionStorage, tab-scoped) and
 * `AppInner` reads + fires it exactly once after the destination has booted.
 */
const KEY = 'taskmagix.flashToast'

/** Queue a toast to fire after the next hard navigation. */
export function setFlashToast(message, type = 'success') {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ message, type }))
  } catch {
    // sessionStorage unavailable (private mode / disabled) — best-effort only.
  }
}

/** Read + clear the queued flash toast (returns `{ message, type }` or null). */
export function consumeFlashToast() {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    sessionStorage.removeItem(KEY)
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed.message !== 'string') return null
    return parsed
  } catch {
    return null
  }
}
